export default "__VITE_ASSET__DfrYRv4Z__"